class HelpAndFeedback {
    constructor() {
        this.handleEngageToggle();
        this.reportIssueFormValidation();
        this.showPopUpFeedbackActions();
        this.validateFeedbackForm();
        this.openFeedback();
    }
    openFeedback(){
        let thisClass = this;
        let giveUsFeedbackBtn = document.querySelector('#kt_app_engage .app-engage-btn[data-action-open=feedback-star-rating]');
        if(giveUsFeedbackBtn){
            giveUsFeedbackBtn.addEventListener("click", function (e) {
                $('#feedback-rating-box').fadeIn();
            });
        }
    }
    handleEngageToggle() {
        let engage = document.querySelector('#kt_app_engage');
        let engageToggleOn = document.querySelector('#kt_app_engage_toggle_on');
        let engageToggleOff = document.querySelector('#kt_app_engage_toggle_off');
        let feedbackRatingBox = document.querySelector('#feedback-rating-box');

        if ( engage && engageToggleOn && engageToggleOff ) {
            //show menu after click on menu button
            engageToggleOff.addEventListener("click", function (e) {
                engage.classList.add('app-engage-hide');
            });

            //hide menu after click on menu button
            engageToggleOn.addEventListener("click", function (e) {
                if(feedbackRatingBox && (!feedbackRatingBox.style.display || feedbackRatingBox.style.display === 'none')){
                    engage.classList.remove('app-engage-hide');
                }
            });

            //hide menu after click on menu item
            $('.help-and-feedback.app-engage-btn').on('click', function (e) {
                engage.classList.add('app-engage-hide');
            });
        }
    }
    reportIssueFormValidation(){
        let form = document.getElementById('frm-reportIssueForm-reportIssueForm');
        if(form){
            let submitButton = document.getElementById('report_issue_form_submit');

            FormValidation.formValidation(
                form,
                {
                    fields: {
                        'description': {
                            validators: {
                                notEmpty: {
                                    message: 'Issue description is required'
                                }
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                        }),
                    }
                }
            ).on('core.form.validating', function(event) {
                new DismissModal('report_issue_modal').disable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                new DismissModal('report_issue_modal').enable();
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }
    }
    showPopUpFeedbackActions(){
        /** Check if we can show feedback form to user - if not check release updates */
        const thisClass = this;
        $.ajax({
            url: '?do=checkIfShowFeedback',
            type: 'GET',
            dataType: '',
        }).done(function (data) {
            if(data){
                /** Show feedback rating after 4s */
                setTimeout(function() {
                    $('#feedback-rating-box').fadeIn();
                }, 4000);
            } else {
                // thisClass.releaseUpdates();
            }
        });
        /** When user click on Show me later - show this feedback form after 1 or 3 months */
        $('#showMeLater').on('click', function() {
            $('#feedback-rating-box').fadeOut();
            $.ajax({
                url: '?do=updateShowFeedback',
                type: 'POST',
                dataType: '',
            }).done(function () {

            });
        });
    }
    validateFeedbackForm(){
        let form = document.getElementById('frm-feedbackForm-feedbackForm');
        if(form){
            let submitButton = document.getElementById('submit_feedback_form_submit');
            let validator = FormValidation.formValidation(
                form,
                {
                    fields: {
                        rating: {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required',
                                },
                            }
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        })
                    }
                }
            )

            $('#frm-feedbackForm-feedbackForm input[name="rating"]').click(function(e) {
                if($(this).val() < 7){
                    $('#feedback_question').text('What disappointed you the most?');
                } else if($(this).val() < 9){
                    $('#feedback_question').text('What should we improve?');
                } else {
                    $('#feedback_question').text( 'What do you like the most?');
                }
                document.getElementById('feedback_reason_wrapper').classList.remove('d-none');
            });

            submitButton.addEventListener('click', function (e) {
                // Prevent default button action
                e.preventDefault();
                validator.validate().then(function(status) {
                    if(status === 'Valid'){
                        submitButton.setAttribute('data-kt-indicator', 'on');
                        submitButton.disabled = true;
                        $('#frm-feedbackForm-feedbackForm').submit();
                    }
                });
            });

            $.nette.ext('feedbackForm', {
                success: function (payload, status, jqXHR, settings) {
                    let formID = settings.nette.form[0].attributes.id.value;
                    if(formID === 'frm-feedbackForm-feedbackForm'){
                        if(typeof payload.feedback !== 'undefined'){
                            // Show loading indication
                            submitButton.setAttribute('data-kt-indicator', 'off');
                            // Disable button to avoid multiple click
                            submitButton.disabled = false;
                            if(payload.feedback.rating > 8){
                                Swal.fire({
                                    title: '<strong>Thank you!</strong>',
                                    html: `<span class="text-center text-primary">We’re thrilled to hear you’ve had a great experience! Your feedback is invaluable to us. Would you be willing to share your thoughts on independent review platforms? <br>As a token of our appreciation, we’re offering up to US$ 200 in gift cards for your time.</span>`,
                                    icon: "success",
                                    buttonsStyling: false,
                                    showCancelButton: true,
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    confirmButtonText: 'I’d love to help',
                                    cancelButtonText: 'Maybe later',
                                    customClass: {
                                        confirmButton: 'btn btn-danger mt-0',
                                        cancelButton: 'btn btn-light-primary mt-0',
                                    },
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        let feedbackGiftModal = document.getElementById('feedback_gift_modal');
                                        if(feedbackGiftModal){
                                            bootstrap.Modal.getOrCreateInstance(feedbackGiftModal).show();
                                            new DismissModal('feedback_gift_modal').disable(true);
                                        }
                                        if(payload.feedback.uuid){
                                            $.ajax({
                                                url: '?do=sendFeedbackEmail',
                                                type: 'GET',
                                                dataType: '',
                                                data: {
                                                    feedbackID: payload.feedback.uuid
                                                }
                                            }).done(function (data) {
                                            });
                                        }
                                    }
                                })
                            } else {
                                toastr.success('Thank you for your feedback!');
                            }
                        } else {
                            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
                        }
                        $('#feedback-rating-box').fadeOut();
                    }
                }
            });
        }
    }
    releaseUpdates(){
        const thisClass = this;
        $.ajax({
            url: '?do=getReleaseUpdates',
            type: 'GET',
            dataType: '',
        }).done(function (data) {
            if(data.length > 0){
                let mainSubject = data[0]["subject"];
                let content = '';
                for(let i = 0; i < data.length; i++){
                    content += '<div class="newRelease mb-4">' +
                        '               <div class="releaseSubject fw-bolder pb-5">'+data[i]["subject"]+'</div>' +
                        '               <div class="release-header">' +
                        '                   <span class="releaseVersion fw-bolder">'+data[i]["version"]+'</span> / ' +
                        '                   <span class="releaseDate">'+data[i]["date"]+'</span>' +
                        '               </div>' +
                        '               <div class="contentRelease">'+data[i]["content"]+'</div>' +
                        '           </div>';
                }
                $('#features .tab-content').html(content);
                $('.featuresInfo .featureText').html(mainSubject);

                $("#featuresExpand").one('click',function(){
                    thisClass.closeReleaseUpdates();
                    $("#features .featuresInfo").hide(500);
                    $('#features').animate({
                        width: '+=150px'
                    }, 500);
                    $("#featuresExpandText").show(500);
                    $(this).hide();
                });

                $("#features .close").on('click',function(){
                    thisClass.closeReleaseUpdates();
                    $("#features").fadeOut(500);
                });

                setTimeout(function() {
                    $('#features').fadeIn();
                }, 4000);
            }
        });
    }
    closeReleaseUpdates(){
        $.ajax({
            url: '?do=closeFeatures',
            type: 'GET',
            dataType: '',
            data: {}
        }).done(function(data) {

        });
    }
}
window.HelpAndFeedback = HelpAndFeedback;